<template>
	<div v-if="formShow" class="signup-root">
		<loader :dialog="loading"></loader>
		<otp :dialog="dialog"></otp>

		<!-- Pill badge -->
		<span class="signup-badge">CEZ FITNESS CLUB</span>

		<!-- Titre & sous-titre -->
		<h2 class="signup-title">Créez votre compte</h2>
		<p class="signup-subtitle">Rejoignez la famille CEZ Fitness</p>

		<!-- Formulaire -->
		<v-form ref="form" v-model="valid" lazy-validation class="mt-5">

			<!-- Nom et prénom -->
			<v-text-field
				v-model="name"
				:rules="nameRules"
				label="Nom et prénom"
				required
				outlined
				dense
				prepend-inner-icon="mdi-account-outline"
				color="blue darken-2"
				class="signup-field"
			></v-text-field>

			<!-- CNI + Email -->
			<v-row dense class="mb-0">
				<v-col cols="6">
					<v-text-field
						v-model="cni"
						:rules="cniRules"
						label="CNI"
						required
						outlined
						dense
						prepend-inner-icon="mdi-card-account-details-outline"
						color="blue darken-2"
						class="signup-field"
					></v-text-field>
				</v-col>
				<v-col cols="6">
					<v-text-field
						v-model="email"
						:rules="emailRules"
						label="Email"
						required
						outlined
						dense
						prepend-inner-icon="mdi-email-outline"
						color="blue darken-2"
						class="signup-field"
					></v-text-field>
				</v-col>
			</v-row>

			<!-- Téléphone + Rôle -->
			<v-row dense class="mb-0">
				<v-col cols="6">
					<v-text-field
						v-model="phone"
						:rules="phoneRules"
						label="Téléphone"
						required
						outlined
						dense
						prepend-inner-icon="mdi-phone-outline"
						color="blue darken-2"
						class="signup-field"
					></v-text-field>
				</v-col>
				<v-col cols="6">
					<v-select
						v-model="role"
						:rules="roleRules"
						:items="roles"
						label="Rôle"
						outlined
						dense
						prepend-inner-icon="mdi-briefcase-outline"
						color="blue darken-2"
						class="signup-field"
					></v-select>
				</v-col>
			</v-row>

			<!-- Salle -->
			<v-select
				v-model="salle"
				:items="sallesList"
				:item-text="s => s.address ? s.name + ' (' + s.address + ')' : s.name"
				item-value="_id"
				label="Salle associée (optionnel)"
				outlined
				dense
				prepend-inner-icon="mdi-domain"
				color="blue darken-2"
				class="signup-field"
				:loading="sallesLoading"
				clearable
			></v-select>

			<!-- Mot de passe -->
			<v-text-field
				v-model="password"
				:rules="passwordRules"
				label="Mot de passe"
				required
				outlined
				dense
				prepend-inner-icon="mdi-lock-outline"
				:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
				@click:append="() => (showPassword = !showPassword)"
				:type="showPassword ? 'password' : 'text'"
				color="blue darken-2"
				class="signup-field"
			></v-text-field>

			<!-- Erreur -->
			<v-alert
				v-if="error"
				type="error"
				dense
				border="left"
				colored-border
				text
				class="mb-4"
			>
				{{ errorMessage }}
			</v-alert>

			<!-- Bouton principal -->
			<v-btn
				:disabled="!valid"
				depressed
				large
				block
				class="submit-btn"
				@click="validate"
			>
				<v-icon left>mdi-account-plus</v-icon>
				S'enregistrer
			</v-btn>

		</v-form>

		<!-- Séparateur -->
		<div class="or-divider">
			<span class="or-line"></span>
			<span class="or-text">ou</span>
			<span class="or-line"></span>
		</div>

		<!-- Lien connexion -->
		<p class="has-account-text">Déjà membre ?</p>
		<v-btn
			outlined
			block
			color="blue darken-2"
			class="signin-link-btn"
			@click="removeForm()"
		>
			Se connecter
		</v-btn>

	</div>
</template>

<script>
import service from "@/services";
import Otp from "../Otp.vue";
import Loader from "../Loader.vue";
export default {
	components: { Otp, Loader },
	props: ["formShow"],
	data: () => ({
		loading: false,
		valid: true,
		showPassword: true,
		role: "",
		salle: null,
		sallesList: [],
		sallesLoading: false,
		error: false,
		errorMessage: "",
		roleRules: [(v) => !!v || "Sélectionnez le rôle"],
		roles: ["SECRETAIRE", "COACH"],
		name: "",
		nameRules: [(v) => !!v || "Entrez votre nom et prénom"],
		phone: "",
		phoneRules: [
			(v) => !!v || "Entrez un numéro de téléphone",
			(v) =>
				(v && v.length <= 9) ||
				"Le numéro de téléphone doit avoir 9 chiffres",
		],
		password: "",
		passwordRules: [
			(v) => !!v || "Entrez votre mot de passe",
			(v) =>
				(v && v.length >= 8) ||
				"Le mot de passe doit avoir au moins 8 caractères",
		],
		email: "",
		emailRules: [(v) => !!v || "Entrez votre Email"],
		cni: "",
		cniRules: [(v) => !!v || "Entrez votre numéro de CNI"],
		dialog: false,
	}),

	created() {
		this.loadSalles();
	},

	methods: {
		loadSalles() {
			this.sallesLoading = true;
			service.getVenues()
				.then((r) => {
					this.sallesList = r.data?.salles || [];
					this.sallesLoading = false;
				})
				.catch(() => { this.sallesLoading = false; });
		},
		validate() {
			this.error = false;
			if (this.$refs.form.validate()) {
				this.loading = true;
				service
					.register({
						fullName: this.name,
						role: this.role,
						phone: this.phone,
						password: this.password,
						email: this.email,
						cni: this.cni,
						...(this.salle ? { salle: this.salle } : {}),
					})
					.then(() => {
						this.loading = false;
						this.dialog = true;
					})
					.catch((err) => {
						this.error = true;
						this.errorMessage = err.message;
						this.loading = false;
					});
			}
		},
		removeForm() {
			this.$emit("changeForm");
		},
	},
};
</script>

<style scoped>
.signup-root {
	font-family: Montserrat, sans-serif;
}

/* ─── Badge ─── */

.signup-badge {
	display: inline-block;
	padding: 5px 14px;
	background: linear-gradient(135deg, #c62828, #1565c0);
	color: #ffffff;
	font-size: 0.60rem;
	font-weight: 700;
	letter-spacing: 2.5px;
	text-transform: uppercase;
	border-radius: 50px;
	margin-bottom: 16px;
}

/* ─── En-tête ─── */

.signup-title {
	font-size: 1.9rem;
	font-weight: 800;
	color: #111827;
	margin: 0 0 5px;
	letter-spacing: 0.2px;
}

.signup-subtitle {
	font-size: 0.80rem;
	color: #9ca3af;
	margin: 0;
}

/* ─── Champs ─── */

.signup-field >>> .v-input__slot {
	border-radius: 10px !important;
}

/* ─── Bouton principal ─── */

.submit-btn {
	background: #c62828 !important;
	color: #ffffff !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.85rem;
	letter-spacing: 2px;
	text-transform: uppercase;
	height: 50px !important;
	border-radius: 10px !important;
	box-shadow: 0 6px 22px rgba(198, 40, 40, 0.40) !important;
	transition: all 0.22s ease !important;
}

.submit-btn:hover:not(.v-btn--disabled) {
	box-shadow: 0 10px 30px rgba(198, 40, 40, 0.55) !important;
	transform: translateY(-2px);
}

.submit-btn.v-btn--disabled {
	background: #e5e7eb !important;
	color: #9ca3af !important;
	box-shadow: none !important;
}

/* ─── Séparateur ─── */

.or-divider {
	display: flex;
	align-items: center;
	gap: 12px;
	margin: 22px 0 16px;
}

.or-line {
	flex: 1;
	height: 1px;
	background: #e5e7eb;
	display: block;
}

.or-text {
	font-size: 0.68rem;
	font-weight: 700;
	color: #c4c4c4;
	letter-spacing: 1.5px;
	text-transform: uppercase;
}

/* ─── Section connexion ─── */

.has-account-text {
	font-size: 0.80rem;
	color: #6b7280;
	text-align: center;
	margin-bottom: 10px;
}

.signin-link-btn {
	font-family: Montserrat, sans-serif !important;
	font-weight: 600 !important;
	letter-spacing: 1px !important;
	border-radius: 10px !important;
	height: 46px !important;
}
</style>

